import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const Panel = styled.div`
  padding: 80px 0;
  text-align: center;
  > h1 {
    font-family: "Open Sans", sans-serif;
    font-weight: 600;
  }
  > p { color: #999; }
  > div { padding-top: 20px; }
  > div a:first-child { margin-right: 20px; }
`

function LanderPanel() {
  return (
    <Panel>
      <h1>NHJ - Boletos e Faturas</h1>
      <p>Bem vindo. Efetue o login para acessar seus arquivos.</p>
      <div>
        <Link to="/login" className="btn btn-info btn-lg">Login</Link>
      </div>
    </Panel>
  )
}

export default LanderPanel
